import MagstimTable from './MagstimTable';

import { CurrentLang } from 'common'

class MagstimTableUser extends MagstimTable {


	initForSelect = (data, heightPx) => {
		// console.log(`MagstimTablePatient.initForSelect(${JSON.stringify(data)}, ${heightPx})`);
		this.initTable(this.configTableData(data), heightPx);
	}

	initForEdit = (data, heightPx) => {
		this.initTable(this.configTableData(data), heightPx);
	}

	configTableData(data) {
		return {
			columns: [
				{ title: CurrentLang().user_user_name, property: 'UserName', isSearchable:true },
				{ title: CurrentLang().user_first_name, property: 'FirstName', isSearchable:true },
				{ title: CurrentLang().user_last_name, property: 'LastName', isSearchable:true },
				{ title: CurrentLang().user_roles, property: 'UserTypeStr' },
				{ title: CurrentLang().organisation, property: 'Organisation', isSearchable:true },
				{ title: CurrentLang().clinic, property: 'Clinic', isSearchable:true },
				{ title: CurrentLang().patient_status, property: 'Status', alwaysSortedDirection: 1, formatter: this.formatStatus }
			],
			data: data
		};
	}

	resetFilters() {
		// console.log('MagstimTablePatient.resetFilters');
		super.resetFilters();
		this.addFilter('Status', 'Active');
	}

}

export default MagstimTableUser;